<div class="login-container">
  <p-progressSpinner class="login-spinner"></p-progressSpinner>
  <p i18n="@@login.redirecting">Redirecting to sign in...</p>
</div>
